<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content *ngIf="isLoaded">

  <mat-card appearance="outlined">
    <mat-list class="detail">
      <mat-list-item *ngFor="let key of objectKeys(boundProfile)"><span class="label">{{key}}</span><span [innerHTML]=boundProfile[key]></span></mat-list-item>
      <ng-container *ngIf="apiKey" class="highlight">
        <mat-list-item><span class="label">API Key:</span>{{apiKey}}</mat-list-item>
      </ng-container>

    </mat-list>
  </mat-card>

  <div class="spacer"></div>

  <data-table #groupTable (detail)="onGroupDetail($event)" (remove)="onGroupRemove($event)" [columns]="groupColumns"
              [dataProviderParams]="groupParams" [dataProvider]="groupHasProfileService" title='Assigned to groups'></data-table>

</page-content>
